"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1887],{

/***/ 61887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20803);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_icons_VahakLogoBlue_n_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70621);
/* harmony import */ var _vahak_core_dist_icons_VahakLogoWhite_n_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19814);
/* harmony import */ var _common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96696);
/* harmony import */ var _homepage_v2_compact_load_posting_CompactLoadPostingProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56193);
/* harmony import */ var _homepage_v2_hero_section_quote_form_card_fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68416);
/* harmony import */ var _homepage_v2_hero_section_quote_form_card_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(62095);
/* harmony import */ var _homepage_v2_hero_section_quote_form_card_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_homepage_v2_hero_section_quote_form_card_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61706);
/* harmony import */ var _lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3749);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29185);
/* harmony import */ var _lcv_route_landing_lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11529);
/* harmony import */ var _lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48336);
/* harmony import */ var _lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _lcv_route_landing_useLcvRouteLandingTranslation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70812);
/* harmony import */ var _service_pages_marketplace_marketplace_v3_useMarketplaceV3PageSeo__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11144);























var RouteLink = function(param) {
    var href = param.href, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: className,
            children: children
        })
    });
};
var Header = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["site-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouteLink, {
            href: "/",
            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["logo-link"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_VahakLogoBlue_n_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["logo-svg"]),
                "aria-label": "Vahak"
            })
        })
    });
};
var DROP_FIELD_ICON = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
    iconClassName: "ti ti-navigation"
});
var PICKUP_FIELD_ICON = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
    iconClassName: "ti ti-map-pin"
});
var Hero = function(param) {
    var cityContent = param.cityContent, formRef = param.formRef, heroCtaRef = param.heroCtaRef, onBookLorryNow = param.onBookLorryNow, isCompactPostingOpen = param.isCompactPostingOpen, destination = param.destination, onDestinationChange = param.onDestinationChange, source = param.source, onSourceChange = param.onSourceChange, _bothFieldsEditable = param.bothFieldsEditable, bothFieldsEditable = _bothFieldsEditable === void 0 ? false : _bothFieldsEditable, eyebrow = param.eyebrow, headline1 = param.headline1, ctaLabel = param.ctaLabel, priceEstimatePrompt = param.priceEstimatePrompt, priceEstimateLink = param.priceEstimateLink, pickupAriaLabel = param.pickupAriaLabel, pickupPlaceholder = param.pickupPlaceholder;
    var openPosting = function() {
        if (isCompactPostingOpen) {
            return;
        }
        onBookLorryNow();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().hero),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["hero-copy"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["eyebrow-kw"]),
                        children: eyebrow
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["hero-h1"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["headline-1"]),
                                children: headline1
                            }),
                            cityContent.heroHeadline2Lines.map(function(line) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["headline-2"]),
                                    children: line
                                }, line);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["hero-sub"]),
                        children: cityContent.heroSub
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["hero-form-card"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["load-form"]),
                    id: "load-form",
                    ref: formRef,
                    onSubmit: function(event) {
                        event.preventDefault();
                        openPosting();
                    },
                    children: [
                        bothFieldsEditable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_homepage_v2_hero_section_quote_form_card_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_21___default().root), (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pickupLocationField)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homepage_v2_hero_section_quote_form_card_fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                id: "lorry-pickup",
                                name: "pickup",
                                placeholder: pickupPlaceholder !== null && pickupPlaceholder !== void 0 ? pickupPlaceholder : cityContent.dropPlaceholder,
                                icon: PICKUP_FIELD_ICON,
                                value: source,
                                onChange: onSourceChange !== null && onSourceChange !== void 0 ? onSourceChange : function() {
                                    return undefined;
                                },
                                locationSearchSource: _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_7__/* .LocationSearchSource.HomepageV2LoadSourcePosting */ .T5.HomepageV2LoadSourcePosting,
                                fieldRole: "pickup",
                                portalMenu: true
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().field),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    iconClassName: "ti ti-map-pin"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "text",
                                    name: "pickup",
                                    id: "pickup",
                                    defaultValue: cityContent.pickupCity,
                                    "aria-label": pickupAriaLabel,
                                    readOnly: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_homepage_v2_hero_section_quote_form_card_QuoteFormFields_module_scss__WEBPACK_IMPORTED_MODULE_21___default().root), (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().dropLocationField)),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homepage_v2_hero_section_quote_form_card_fields_QuoteFormLocationField__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                id: "city-drop",
                                name: "drop",
                                placeholder: cityContent.dropPlaceholder,
                                icon: DROP_FIELD_ICON,
                                value: destination,
                                onChange: onDestinationChange,
                                locationSearchSource: _vahak_core_dist_services_city_search_service__WEBPACK_IMPORTED_MODULE_7__/* .LocationSearchSource.HomepageV2LoadDestinationPosting */ .T5.HomepageV2LoadDestinationPosting,
                                fieldRole: "drop",
                                portalMenu: bothFieldsEditable
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["hero-actions"]),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "submit",
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["btn-primary"]),
                                    id: "hero-cta-btn",
                                    ref: heroCtaRef,
                                    disabled: isCompactPostingOpen,
                                    children: ctaLabel
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["price-link"]),
                                    children: [
                                        priceEstimatePrompt,
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#",
                                            onClick: function(event) {
                                                event.preventDefault();
                                                openPosting();
                                            },
                                            "aria-disabled": isCompactPostingOpen,
                                            children: priceEstimateLink
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var TrustStrip = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["trust-strip"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                iconClassName: "ti ti-shield-check"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: text
            })
        ]
    });
};
var HowItWorks = function(param) {
    var title = param.title, steps = param.steps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["steps-block"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["steps-title"]),
                children: title
            }),
            steps.map(function(text, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["step-row"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["step-num"]),
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["step-text"]),
                            children: text
                        })
                    ]
                }, text);
            })
        ]
    });
};
var AboutBlock = function(param) {
    var title = param.title, aboutText = param.aboutText, tags = param.tags;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["about-block"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["about-title"]),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["about-text"]),
                children: aboutText
            }),
            tags.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["tag-row"]),
                children: tags.map(function(tag) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().tag),
                        children: tag
                    }, tag);
                })
            }) : null
        ]
    });
};
var ProofModule = function(param) {
    var proofLabel = param.proofLabel, stats = param.stats, features = param.features;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["proof-card"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["proof-label"]),
                        children: proofLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["stat-grid"]), (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["cols-2"])),
                        children: stats.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["stat-cell"]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["stat-num"]),
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["stat-label"]),
                                        children: item.label
                                    })
                                ]
                            }, item.label);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["feature-row"]),
                children: features.map(function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["feature-item"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                iconClassName: item.iconClassName
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: item.label
                            })
                        ]
                    }, item.label);
                })
            })
        ]
    });
};
var LocalResources = function(param) {
    var title = param.title, dhabas = param.dhabas, contacts = param.contacts, moreToggle = param.moreToggle, note = param.note;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["local-block"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["block-title"]),
                children: title
            }),
            dhabas.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["dhaba-row"]),
                children: dhabas.map(function(dhaba) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["dhaba-card"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().name),
                                children: dhaba.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().loc),
                                children: dhaba.location
                            })
                        ]
                    }, "".concat(dhaba.name, "-").concat(dhaba.location));
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: contacts.map(function(contact) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["contact-row"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: contact.label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().num),
                                children: contact.number
                            })
                        ]
                    }, "".concat(contact.label, "-").concat(contact.number));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("details", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["more-toggle"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", {
                    children: moreToggle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["local-note"]),
                children: note
            })
        ]
    });
};
var ChipBlock = function(param) {
    var label = param.label, chips = param.chips;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["chip-block"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["chip-label"]),
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["chip-row"]),
                children: chips.map(function(chip) {
                    return chip.href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouteLink, {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().chip),
                        href: chip.href,
                        children: chip.label
                    }, chip.label) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().chip),
                        children: chip.label
                    }, chip.label);
                })
            })
        ]
    });
};
var SeoContent = function(param) {
    var cityContent = param.cityContent, faqTitle = param.faqTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-block"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["block-title"]),
                        children: faqTitle
                    }),
                    cityContent.faqs.map(function(faq) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("details", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-item"]),
                            open: faq.defaultOpen,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", {
                                    children: faq.question
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-answer"]),
                                    children: faq.answer
                                })
                            ]
                        }, faq.question);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChipBlock, {
                label: cityContent.popularRoutesLabel,
                chips: cityContent.popularRoutes
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChipBlock, {
                label: cityContent.vehicleTypesLabel,
                chips: cityContent.vehicleTypes
            })
        ]
    });
};
var FooterGroup = function(param) {
    var group = param.group;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-group"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["fg-label"]),
                children: group.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["fg-links"]),
                children: [
                    (ref = group.links) === null || ref === void 0 ? void 0 : ref.map(function(link) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouteLink, {
                            href: link.href,
                            children: link.label
                        }, link.href);
                    }),
                    (ref1 = group.textItems) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["fg-text"]),
                            children: item
                        }, item);
                    }),
                    group.moreLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouteLink, {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["fg-more"]),
                        href: group.moreLink.href,
                        children: group.moreLink.label
                    }) : null
                ]
            })
        ]
    });
};
var Footer = function(param) {
    var footerSeoText = param.footerSeoText, brandText = param.brandText, groups = param.groups, playStoreLabel = param.playStoreLabel, copyright = param.copyright, madeInIndia = param.madeInIndia;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["site-footer"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-seo-text"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: footerSeoText
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["wrap-footer"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-brand"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["logo-row"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouteLink, {
                                    href: "/",
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["logo-link"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_VahakLogoWhite_n_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-logo-svg"]),
                                        "aria-label": "Vahak"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: brandText
                            })
                        ]
                    }),
                    groups.map(function(group) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterGroup, {
                            group: group
                        }, group.label);
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-social"]),
                children: _lcv_route_landing_lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_17__/* .LCV_ROUTE_SOCIAL_LINKS.map */ .te.map(function(socialLink) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: socialLink.href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": socialLink.label,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            iconClassName: socialLink.iconClassName
                        })
                    }, socialLink.href);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-app"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: _lcv_route_landing_lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_17__/* .LCV_ROUTE_PLAY_STORE_URL */ .rp,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lcv_route_landing_LcvRouteIcon__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            iconClassName: "ti ti-brand-google-play"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: playStoreLabel
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-bottom"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: copyright
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["footer-made"]),
                        children: madeInIndia
                    })
                ]
            })
        ]
    });
};
var StickyCta = function(param) {
    var isVisible = param.isVisible, onClick = param.onClick, isCompactPostingOpen = param.isCompactPostingOpen, ctaLabel = param.ctaLabel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["sticky-cta"]), isVisible && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["is-visible"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            type: "button",
            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["btn-primary"]),
            onClick: onClick,
            disabled: isCompactPostingOpen,
            children: ctaLabel
        })
    });
};
var CityLandingPage = function(param) {
    var cityConfig = param.cityConfig, marketplaceLorry = param.marketplaceLorry;
    var ref;
    var isMarketplaceLorry = Boolean(marketplaceLorry);
    var t = (0,_lcv_route_landing_useLcvRouteLandingTranslation__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)().t;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), _locale = ref1.locale, locale = _locale === void 0 ? "en" : _locale;
    var compactPosting = (0,_homepage_v2_compact_load_posting_CompactLoadPostingProvider__WEBPACK_IMPORTED_MODULE_12__/* .useCompactLoadPostingOptional */ .qA)();
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var heroCtaRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isStickyCtaVisible = ref2[0], setIsStickyCtaVisible = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), destination = ref3[0], setDestination = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), source = ref4[0], setSource = ref4[1];
    var isCompactPostingOpen = Boolean(compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.isCompactPostingOpen);
    var ref5, ref6;
    var marketplaceSeo = (0,_service_pages_marketplace_marketplace_v3_useMarketplaceV3PageSeo__WEBPACK_IMPORTED_MODULE_19__/* .useMarketplaceV3PageSeo */ .Z)((ref5 = marketplaceLorry === null || marketplaceLorry === void 0 ? void 0 : marketplaceLorry.urlSrc) !== null && ref5 !== void 0 ? ref5 : "", (ref6 = marketplaceLorry === null || marketplaceLorry === void 0 ? void 0 : marketplaceLorry.urlDest) !== null && ref6 !== void 0 ? ref6 : "", isMarketplaceLorry ? _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_6__/* .MarketPlaceType.LORRY */ .CY3.LORRY : _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_6__/* .MarketPlaceType.LOAD */ .CY3.LOAD);
    var cityContent = isMarketplaceLorry ? marketplaceSeo.landingContent : t("cities.".concat(cityConfig.slug), {
        returnObjects: true
    });
    var howItWorksSteps = t("howItWorks.steps", {
        returnObjects: true
    });
    var features = t("features", {
        returnObjects: true
    });
    var footerGroups = ((ref = cityContent.footerGroups) === null || ref === void 0 ? void 0 : ref.length) ? cityContent.footerGroups : t("footer.groups", {
        returnObjects: true
    });
    var faqList = cityContent.faqs.map(function(faq) {
        return {
            question: faq.question,
            answer: faq.answer
        };
    });
    var isKannada = locale === "kn";
    var isHindi = locale === "hi" || locale === "mr";
    var isTelugu = locale === "te";
    var isGujarati = locale === "gu";
    var isBengali = locale === "bn";
    var isTamil = locale === "ta";
    var proofStats = cityContent.proofStats.length ? cityContent.proofStats : t("proof.stats", {
        returnObjects: true
    });
    var trustStripText = cityContent.trustStrip || t("trustStrip", (0,_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .getPlatformStatI18nLabels */ .E)());
    var postingSourceScreen = isMarketplaceLorry ? _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_8__/* .WEB_V2_SOURCE_SCREENS.MARKETPLACE */ .ZM.MARKETPLACE : _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_8__/* .WEB_V2_SOURCE_SCREENS.LCV_CITY_LANDING */ .ZM.LCV_CITY_LANDING;
    var handleBookLorryNow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.openCompactPosting(isMarketplaceLorry ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, source ? {
            source: source
        } : {}, destination ? {
            destination: destination
        } : {}) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
            source: cityConfig.city
        }, destination ? {
            destination: destination
        } : {}), {
            eventData: {
                source_screen: postingSourceScreen
            }
        });
    }, [
        cityConfig,
        compactPosting,
        destination,
        isMarketplaceLorry,
        postingSourceScreen,
        source
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var heroBtn = heroCtaRef.current;
        if (!heroBtn || typeof IntersectionObserver === "undefined") {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                setIsStickyCtaVisible(!entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(heroBtn);
        return function() {
            observer.disconnect();
        };
    }, []);
    var _heroEyebrow, _heroHeadline1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_page_meta_tags_PageMetaTags__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, isMarketplaceLorry ? {
                asPath: marketplaceSeo.asPath,
                localeNeutralPath: marketplaceSeo.marketplaceSeoPath,
                title: marketplaceSeo.pageMeta.title,
                description: marketplaceSeo.pageMeta.description,
                keywords: marketplaceSeo.pageMeta.keywords,
                ogImgAltText: marketplaceSeo.pageMeta.ogImgAltText,
                shouldBeIndexed: marketplaceSeo.shouldBeIndexed,
                schema: {
                    breadcrumbItems: marketplaceSeo.breadcrumbItems,
                    faqList: marketplaceSeo.faqList
                }
            } : {
                title: cityContent.seo.title,
                description: cityContent.seo.description,
                locale: locale,
                localeNeutralPath: (0,_data__WEBPACK_IMPORTED_MODULE_16__/* .getCityPagePath */ .l_)(cityConfig.slug),
                hreflangLocales: cityConfig.hreflangLocales,
                ogType: "website",
                ogSiteName: "Vahak",
                ogImgAltText: cityContent.seo.title,
                includeDefaultSchema: true,
                schema: {
                    breadcrumbItems: [
                        {
                            name: t("meta.breadcrumbHome"),
                            url: (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_14__/* .getHomeUrl */ .cd)()
                        },
                        {
                            name: t("meta.breadcrumbLcvBooking"),
                            path: "/lcv-booking"
                        },
                        {
                            name: cityContent.breadcrumbCityName
                        }
                    ],
                    faqList: faqList
                }
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().page), isKannada && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageKn), isHindi && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageHi), isTelugu && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageTe), isGujarati && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageGu), isBengali && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageBn), isTamil && (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default().pageTa)),
                lang: locale,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Header, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hero, {
                        cityContent: cityContent,
                        formRef: formRef,
                        heroCtaRef: heroCtaRef,
                        onBookLorryNow: handleBookLorryNow,
                        isCompactPostingOpen: isCompactPostingOpen,
                        destination: destination,
                        onDestinationChange: setDestination,
                        source: source,
                        onSourceChange: setSource,
                        bothFieldsEditable: isMarketplaceLorry,
                        eyebrow: (_heroEyebrow = cityContent.heroEyebrow) !== null && _heroEyebrow !== void 0 ? _heroEyebrow : t("hero.eyebrow"),
                        headline1: (_heroHeadline1 = cityContent.heroHeadline1) !== null && _heroHeadline1 !== void 0 ? _heroHeadline1 : t("hero.headline1"),
                        ctaLabel: t("hero.cta"),
                        priceEstimatePrompt: t("hero.priceEstimatePrompt"),
                        priceEstimateLink: t("hero.priceEstimateLink"),
                        pickupAriaLabel: t("hero.pickupAriaLabel"),
                        pickupPlaceholder: cityContent.pickupPlaceholder
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TrustStrip, {
                        text: trustStripText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowItWorks, {
                        title: t("howItWorks.title"),
                        steps: howItWorksSteps
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutBlock, {
                        title: cityContent.aboutTitle,
                        aboutText: cityContent.aboutText,
                        tags: cityContent.tags
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProofModule, {
                        proofLabel: t("proof.label"),
                        stats: proofStats,
                        features: features
                    }),
                    !isMarketplaceLorry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocalResources, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, cityContent.localResources)) : null,
                    isMarketplaceLorry ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-block"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["block-title"]),
                                children: t("faq.title")
                            }),
                            cityContent.faqs.map(function(faq) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("details", {
                                    className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-item"]),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("summary", {
                                            children: faq.question
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_lcv_route_landing_LcvRouteLandingPage_module_scss__WEBPACK_IMPORTED_MODULE_20___default()["faq-answer"]),
                                            children: faq.answer
                                        })
                                    ]
                                }, faq.question);
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SeoContent, {
                        cityContent: cityContent,
                        faqTitle: t("faq.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
                        footerSeoText: cityContent.footerSeoText,
                        brandText: t("footer.brandText"),
                        groups: footerGroups,
                        playStoreLabel: t("footer.playStore"),
                        copyright: t("footer.copyright"),
                        madeInIndia: t("footer.madeInIndia")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StickyCta, {
                        isVisible: isStickyCtaVisible,
                        onClick: handleBookLorryNow,
                        isCompactPostingOpen: isCompactPostingOpen,
                        ctaLabel: t("hero.cta")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CityLandingPage);


/***/ }),

/***/ 11144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMarketplaceV3PageSeo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50930);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12098);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94280);
/* harmony import */ var _useMarketplaceV3Translation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20065);








var EMPTY_LOCAL_RESOURCES = {
    title: "",
    dhabas: [],
    contacts: [],
    moreToggle: "",
    note: ""
};
function asStringArray(value) {
    return Array.isArray(value) ? value : [];
}
function buildLorryLandingContent(t, seoContext, faqList, pageMeta) {
    var headline2Lines = [];
    var heroSub = "";
    var aboutText = "";
    var tags = [];
    var footerSeoText = "";
    switch(seoContext.kind){
        case "city":
        case "destination":
            headline2Lines = [
                t("lorry.hero.headline2WithCity", {
                    city: seoContext.cityDisplayName
                })
            ];
            heroSub = t("lorry.hero.heroSubWithCity", {
                city: seoContext.cityDisplayName
            });
            aboutText = t("lorry.about.textWithCity", {
                city: seoContext.cityDisplayName
            });
            tags = asStringArray(t("lorry.about.tagsWithCity", {
                returnObjects: true,
                city: seoContext.cityDisplayName
            }));
            footerSeoText = t("lorry.footer.seoTextWithCity", {
                city: seoContext.cityDisplayName
            });
            break;
        case "route":
            headline2Lines = [
                t("lorry.hero.headline2RouteFrom", {
                    fromCity: seoContext.fromCity
                }),
                t("lorry.hero.headline2RouteTo", {
                    toCity: seoContext.toCity
                })
            ];
            heroSub = t("lorry.hero.heroSubWithRoute", {
                fromCity: seoContext.fromCity,
                toCity: seoContext.toCity
            });
            aboutText = t("lorry.about.textWithRoute", {
                fromCity: seoContext.fromCity,
                toCity: seoContext.toCity
            });
            tags = asStringArray(t("lorry.about.tagsWithRoute", {
                returnObjects: true,
                fromCity: seoContext.fromCity,
                toCity: seoContext.toCity
            }));
            footerSeoText = t("lorry.footer.seoTextWithRoute", {
                fromCity: seoContext.fromCity,
                toCity: seoContext.toCity
            });
            break;
        default:
            headline2Lines = asStringArray(t("lorry.hero.headline2Default", {
                returnObjects: true
            }));
            heroSub = t("lorry.hero.heroSubDefault");
            aboutText = t("lorry.about.textDefault");
            tags = asStringArray(t("lorry.about.tagsDefault", {
                returnObjects: true
            }));
            footerSeoText = t("lorry.footer.seoTextDefault");
            break;
    }
    var _breadcrumbLabel;
    return {
        seo: {
            title: pageMeta.title,
            description: pageMeta.description
        },
        pickupCity: "",
        dropPlaceholder: t("lorry.hero.dropPlaceholder"),
        heroEyebrow: t("lorry.hero.eyebrow"),
        heroHeadline1: t("lorry.hero.headline1"),
        pickupPlaceholder: t("lorry.hero.pickupPlaceholder"),
        heroHeadline2Lines: headline2Lines,
        heroSub: heroSub,
        breadcrumbCityName: (_breadcrumbLabel = pageMeta.breadcrumbLabel) !== null && _breadcrumbLabel !== void 0 ? _breadcrumbLabel : "Lorry Marketplace",
        trustStrip: "",
        aboutTitle: t("lorry.about.title"),
        aboutText: aboutText,
        tags: tags,
        proofStats: [],
        localResources: EMPTY_LOCAL_RESOURCES,
        faqs: faqList,
        popularRoutesLabel: "",
        popularRoutes: [],
        vehicleTypesLabel: "",
        vehicleTypes: [],
        footerSeoText: footerSeoText,
        footerGroups: []
    };
}
function useMarketplaceV3PageSeo(urlSrc, urlDest) {
    var marketplaceType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .MarketPlaceType.LOAD */ .CY3.LOAD;
    var t = (0,_useMarketplaceV3Translation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var isLorryMarketplace = marketplaceType === _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .MarketPlaceType.LORRY */ .CY3.LORRY;
    var copyPrefix = isLorryMarketplace ? "lorry." : "";
    var locationSegment = Array.isArray(router.query.params) ? router.query.params[1] : undefined;
    var resolvedLocationSegment = typeof locationSegment === "string" ? locationSegment : undefined;
    var hasLoadLorryDetailQuery = Boolean(router.query.loadbid || router.query.lorrybid);
    var genericFaqList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var items = t("".concat(copyPrefix, "faq.items"), {
            returnObjects: true
        });
        return Array.isArray(items) ? items : [];
    }, [
        copyPrefix,
        t
    ]);
    var seoContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_5__/* .resolveMarketplaceLoadSeoContext */ .sP)({
            locationSegment: resolvedLocationSegment,
            urlSrc: urlSrc,
            urlDest: urlDest
        });
    }, [
        resolvedLocationSegment,
        urlSrc,
        urlDest
    ]);
    var faqList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getMarketplaceLoadFaqList */ .XT)({
            locationSegment: resolvedLocationSegment,
            urlSrc: urlSrc,
            urlDest: urlDest,
            genericFaqList: genericFaqList
        });
    }, [
        genericFaqList,
        resolvedLocationSegment,
        urlDest,
        urlSrc
    ]);
    var pageMeta = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        switch(seoContext.kind){
            case "city":
            case "destination":
                return {
                    title: t("".concat(copyPrefix, "meta.titleWithCity"), {
                        city: seoContext.cityDisplayName
                    }),
                    description: t("".concat(copyPrefix, "meta.descriptionWithCity"), {
                        city: seoContext.cityDisplayName
                    }),
                    keywords: t("".concat(copyPrefix, "meta.keywordsWithCity"), {
                        city: seoContext.cityDisplayName
                    }),
                    ogImgAltText: t("".concat(copyPrefix, "meta.ogImgAltTextWithCity"), {
                        city: seoContext.cityDisplayName
                    }),
                    breadcrumbLabel: seoContext.cityDisplayName
                };
            case "route":
                return {
                    title: t("".concat(copyPrefix, "meta.titleWithRoute"), {
                        fromCity: seoContext.fromCity,
                        toCity: seoContext.toCity
                    }),
                    description: t("".concat(copyPrefix, "meta.descriptionWithRoute"), {
                        fromCity: seoContext.fromCity,
                        toCity: seoContext.toCity
                    }),
                    keywords: t("".concat(copyPrefix, "meta.keywordsWithCity"), {
                        city: seoContext.routeLabel
                    }),
                    ogImgAltText: t("".concat(copyPrefix, "meta.ogImgAltTextWithCity"), {
                        city: seoContext.routeLabel
                    }),
                    breadcrumbLabel: seoContext.routeLabel
                };
            default:
                return {
                    title: t("".concat(copyPrefix, "meta.title")),
                    description: t("".concat(copyPrefix, "meta.description")),
                    keywords: undefined,
                    ogImgAltText: t("".concat(copyPrefix, "meta.ogImgAltText")),
                    breadcrumbLabel: undefined
                };
        }
    }, [
        copyPrefix,
        seoContext,
        t
    ]);
    var inCityTextWithoutIndia = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_marketplace_new_marketplacePageHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getMarketplaceInCityTextForSeoContent */ .Xq)({
            locationSegment: resolvedLocationSegment,
            urlSrc: urlSrc,
            urlDest: urlDest
        });
    }, [
        resolvedLocationSegment,
        urlDest,
        urlSrc
    ]);
    var marketplaceSeoPath = _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl(marketplaceType, urlSrc, urlDest);
    var breadcrumbItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return [
            {
                name: "Home",
                url: (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getHomeUrl */ .cd)()
            },
            {
                name: isLorryMarketplace ? "Lorry Marketplace" : "Load Marketplace",
                path: _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl(marketplaceType)
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(pageMeta.breadcrumbLabel ? [
            {
                name: pageMeta.breadcrumbLabel
            }
        ] : []));
    }, [
        isLorryMarketplace,
        marketplaceType,
        pageMeta.breadcrumbLabel
    ]);
    var landingContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return isLorryMarketplace ? buildLorryLandingContent(t, seoContext, faqList, pageMeta) : undefined;
    }, [
        faqList,
        isLorryMarketplace,
        pageMeta,
        seoContext,
        t
    ]);
    return {
        asPath: router.asPath,
        breadcrumbItems: breadcrumbItems,
        faqList: faqList,
        inCityTextWithoutIndia: inCityTextWithoutIndia,
        landingContent: landingContent,
        marketplaceSeoPath: marketplaceSeoPath,
        pageMeta: pageMeta,
        shouldBeIndexed: !hasLoadLorryDetailQuery
    };
}


/***/ }),

/***/ 20065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42386);

var MARKETPLACE_V3_NAMESPACES = [
    "marketplaceV3",
    "homepageV2",
    "mktCardV2",
    "load-form",
    "navigation",
    "common"
];
var useMarketplaceV3Translation = function() {
    return (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)(MARKETPLACE_V3_NAMESPACES);
};
/* harmony default export */ __webpack_exports__["Z"] = (useMarketplaceV3Translation);


/***/ })

}]);